import autoshopee from './autoshopee';
import tiktok from './tiktok';
import lazada from './lazada';
import subcheo from './subcheo';
import extension from './extension';

export default {
  autoshopee,
  tiktok,
  lazada,
  subcheo,
  extension,
};
